export default "__VITE_ASSET__toxTiE9T__"